import { useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";

export const MedicationImport = () => {
  const ref = useRef(null);
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!window.confirm("Importing replaces the medicines from your last import. Entries staff added or edited in the CRM are kept. Continue?")) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/medications/import", fd);
      toast.success(`Imported ${data.imported} medicines — ${data.matched} matched to patients` +
        (data.unmatched ? `, ${data.unmatched} need matching` : "") + (data.skipped ? `, ${data.skipped} blank rows skipped` : ""));
      qc.invalidateQueries({ queryKey: ["medications"] });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Import failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept=".csv,.xlsx,.xls" className="hidden" onChange={onFile} data-testid="med-import-input" />
      <Button variant="outline" disabled={busy} onClick={() => ref.current?.click()} data-testid="med-import-btn">
        <Upload className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">{busy ? "Importing…" : "Import CSV / Excel"}</span>
      </Button>
    </>
  );
};
